import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import commuteIcon from "../../../../../assets/design-revamp-company/company-detail-headers/commute-icon.svg";
import { useTranslation } from "react-i18next";
import { getCommuteList } from "../../../../../apis/Business/CommuteApi";
import handleToFixedNum from "../../components/HeaderBox/handleToFixedNum";
import formatDate from "../../components/HeaderBox/formatDate";

const CommuteIcon = () => (
  <img src={commuteIcon} alt="Commute Icon" width={76} height={76} />
);

const CommuteHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  businessId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalObjCommute, setTotalObjCommute] = useState([]);
  const [systemBoundaryCommute, setSystemBoundaryCommute] = useState("");
  useEffect(() => {
    getCommuteList({
      businessId: businessId,
      setTotalObj: setTotalObjCommute,
      setSystemBoundaryCommute: setSystemBoundaryCommute,
    });
  }, [businessId]);

  return (
    <CategoryComponent
      show={show}
      className={`commute-category ${className || ""}`}
      leftBoxProps={{
        icon: <CommuteIcon />,
        title: t("COMMUTE"),
        description: t("COMMUTE_INTRO"),
        scopes: [{ scope: t("EMPLOYEE_COMMUTE_SCOPE"), filled: true }],
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_CATEGORY"),
            items: [
              {
                subtitle: t("EMISSIONS") + " (tCO₂e)",
                subitems: [
                  {
                    value: handleToFixedNum(
                      totalObjCommute,
                      totalObjCommute?.total_emissions
                    ),
                  },
                  {
                    value: `${handleToFixedNum(
                      totalObjCommute,
                      totalObjCommute?.total_company_vehicle_carbon
                    )}`,
                  },
                ],
              },
            ],
          },
        ],
        lastUpdated: totalObjCommute?.updated_at
          ? formatDate(totalObjCommute?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      systemBoundaryProps={{
        systemBoundary: systemBoundaryCommute,
        setSystemBoundary: setSystemBoundaryCommute,
        businessId: businessId,
        totalObjCategory: totalObjCommute.category_name,
      }}
      {...props}
    />
  );
};

export default CommuteHeader;
